export const keywordsKeys = [
    {
        key: 'keywords',
        label: 'Keywords',
        type: 'bar',
    },
    {
        key: 'newKeywords',
        label: 'New keywords',
        type: 'bar',
    },
];

export const urlsKeys = [
    {
        key: 'urls',
        label: 'URLs',
        type: 'bar',
    },
    {
        key: 'newURLs',
        label: 'New URLs',
        type: 'bar',
    },
];
